import axios from 'axios'

const apiClient = axios.create({
  baseURL:
    process.env.NODE_ENV === 'development'
      ? 'https://localhost:44383/api/'
      : 'https://dptrials.azurewebsites.net/api/',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache'
  }
})

export default {
  getBaseURL() {
    return apiClient.defaults.baseURL
  },
  setUserToken(token) {
    return (apiClient.defaults.headers.common[
      'Authorization'
    ] = `Bearer ${token}`)
  },
  postLogin(credentials) {
    return apiClient.post('auth/token', credentials)
  },
  sendPasswordReset(credentials) {
    return apiClient.post('user/sendpasswordreset', credentials)
  },
  postResetPassword(id, password) {
    return apiClient.post('user/resetpassword/' + id, { password: password })
  },
  get(object, id = null) {
    if (id) {
      return apiClient.get(object + '/' + id)
    } else {
      return apiClient.get(object)
    }
  },
  post(object, model) {
    return apiClient.post(object, model)
  },
  put(object, id, model) {
    return apiClient.put(object + '/' + id, model)
  },
  delete(object, id) {
    return apiClient.delete(object + '/' + id)
  },
  async getFile(id) {
    const response = await apiClient.get(`report/${id}`, {
      responseType: 'blob'
    })

    const fileBundle = {
      data: response.data,
      extension: 'docx'
    }
    return fileBundle
  }
}
